module.exports = __webpack_public_path__ + "static/media/benefits.c6d90c6d.mp3";